import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioSolicitudMedicamentosPendientesService {

  constructor( private requestUrl: ReportesRequestService ) { }

  public async getAfiliadoOrdenMedica( codigoBaseDatos: string, uncoAdmision: string ) {
    try {
      const response = await this.requestUrl.getRequest(
        'admisiones/afiliado-orden-medica',
        [
          codigoBaseDatos,
          {
            'ln_unco_admsn': uncoAdmision
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;
  }

  public async getDataSolicitudMedicamentosPendientes( params: ObjectSolicitudMedicamentosPendientesRequest ) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-medicamentos-pendientes/data',
        [
          params.codigoBaseDatos,
          {
            'ln_unco_admsn': params.uncoAdmision,
            'ln_unco_emprsa': params.uncoEmpresa
          }
        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;
  }

}

export interface ObjectSolicitudMedicamentosPendientesRequest {
  codigoBaseDatos: string;
  uncoAdmision: string;
  uncoEmpresa: string;
}

export interface AfiliadoOrdenMedicaEntity {
  identificacion: string;
  historiaClinica: string;
  nombre: string;
  fechaNacimiento: string;
  direccion: string;
  telefono: string;
  tipoAfiliado: string;
  sexo: string;
  estrato: string;
  edad: string;
  empresa: string;
  sede: string;
  admision: string;
}

export interface SolicitudOrdenesMedicasEntity {
  fecha: string;
  puntoAtencion: string;
  profesional: string;
  codigoMedicamento: string;
  medicamento: string;
  cantidad: string;
  valorCosto: string;
  via: string;
  dss: string;
  facturacion: string;
  activaEstado: string;
  indicaciones: string;
  numeroAutorizacionEps: string;
  fechaValidez: string;
  validezOrdenAmbulatoria: string;
  consecutivoOrdenesMedicamentos: string;
  valorUnitario: string;
  cantidadRequerida: string;
  notas: string;
  cantidadDescargada: string;
  diagnosticoPrincipal: string;
  diagnosticoRelacionado1: string;
  diagnosticoRelacionado2: string;
  cantidadLetras: string;
  unidadFrecuencia: string;
  consecutivoFormulaMedica: string;
  duracion: string;
  firmaDigital: string;
  identificacionProfesional: string;
  especialidadProfesional: string;
  registroMedico: string;
  presentacion: string;
  sede: string;
}
